"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = exports.EMAIL_MATCHER = void 0;
exports.EMAIL_MATCHER = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
var isValidEmail = function (value) {
    return exports.EMAIL_MATCHER.test(value);
};
exports.isValidEmail = isValidEmail;
